import React from "react";
import { useField } from "formik";
import styled from "styled-components";
import { InputPropsWithoutRef } from "react-html-props";
import FieldErrorMessage from "./FieldErrorMessage";
import FieldLabel from "./FieldLabel";
import FieldHelpText from "./FieldHelpText";
import TextInput from "./TextInput";

const TextInputField = (props: Props) => {
  const { label, helpText, hiddenLabel, prefixDisplay, ...otherProps } = props;
  const [field, meta] = useField<string>(props);

  const showError = Boolean(meta.touched && meta.error);
  const htmlFor = otherProps.id || otherProps.name;

  const value = field.value || "";

  return (
    <FieldWrapper>
      <FieldLabel htmlFor={htmlFor} visuallyHidden={hiddenLabel}>
        {label}
        {helpText && <FieldHelpText>{helpText}</FieldHelpText>}
      </FieldLabel>
      <Field>
        {prefixDisplay && <TextInputPrefix>{prefixDisplay}</TextInputPrefix>}
        <TextInput
          id={htmlFor}
          {...field}
          {...otherProps}
          value={value}
          error={showError}
        />
      </Field>
      <FieldErrorMessage name={otherProps.name} />
    </FieldWrapper>
  );
};

interface Props extends InputPropsWithoutRef {
  label?: string;
  name: string;
  helpText?: string;
  hiddenLabel?: boolean;
  prefixDisplay?: React.ReactNode;
}

const FieldWrapper = styled.div`
  font-family: ${({ theme }) => theme.font};
  margin-bottom: 1.5rem;
`;

const TextInputPrefix = styled.div`
  background-color: ${({ theme }) => theme.colors.gray100};
  border: 2px solid ${({ theme }) => theme.colors.gray300};
  border-right: 0;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Field = styled.div`
  display: flex;

  ${TextInput} {
    flex: 1;
  }

  ${TextInputPrefix} + ${TextInput} {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`;
export default TextInputField;
